import React, { useState } from "react";
import Carousel2 from "../carousel/Carousel_2";
import Footer from "../footer/Footer";
import Location from "../location/Location";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";
import "./Contact.css";

export default function Contact() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    area: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const submitForm = (e) => {
    e.preventDefault();

    setLoading(true);

    const whatsappMessage = `
🛋️ *NEW RK SOFA WORKS ENQUIRY*

👤 *Name:* ${formData.name}
📞 *Phone:* ${formData.phone}
📍 *Area:* ${formData.area || "Not provided"}

💬 *Service Required:*
${formData.message || "No message provided"}

━━━━━━━━━━━━━━━━
*RK Sofa Works*
Sofa Repair • Upholstery • Restoration
`;

    const whatsappURL = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappURL, "_blank");

    setFormData({
      name: "",
      phone: "",
      area: "",
      message: "",
    });

    setLoading(false);
  };

  return (
    <>
      <Navbar />

      <Carousel2 />

      <Offer />

      {/* =====================================================
          CONTACT HERO / INTRO
      ===================================================== */}
      <section className="rk-contact-section" id="contact">
        <div className="container rk-contact-container">

          <div className="rk-contact-heading">

            <div className="rk-contact-kicker">
              <span></span>
              <small>06 — CONTACT RK SOFA WORKS</small>
            </div>

            <h1>
              Let's bring your
              <br />
              sofa back to <em>life.</em>
            </h1>

            <p>
              Tell us what your sofa needs. Share a few details and
              our team will connect with you through WhatsApp to
              understand the repair or restoration work required.
            </p>

          </div>


          {/* =====================================================
              MAIN CONTACT GRID
          ===================================================== */}
          <div className="rk-contact-grid">

            {/* =================================================
                LEFT SIDE
            ================================================= */}
            <div className="rk-contact-info">

              <div className="rk-contact-info-top">

                <span className="rk-contact-label">
                  RK SOFA WORKS
                </span>

                <h2>
                  Repair.
                  <br />
                  Restore.
                  <br />
                  <em>Refresh.</em>
                </h2>

                <p>
                  From everyday sofa repairs to complete upholstery
                  makeovers, we help you extend the life of your
                  furniture with practical, quality workmanship.
                </p>

              </div>


              {/* CONTACT DETAILS */}

              <div className="rk-contact-details">

                <a
                  href={`tel:${PHONE}`}
                  className="rk-contact-detail"
                >
                  <div className="rk-contact-detail-icon">
                    <i className="fa-solid fa-phone"></i>
                  </div>

                  <div>
                    <small>CALL US</small>
                    <strong>+91 93183 33680</strong>
                  </div>

                  <i className="fa-solid fa-arrow-right rk-contact-detail-arrow"></i>
                </a>


                <a
                  href={`https://wa.me/${WHATSAPP}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rk-contact-detail"
                >
                  <div className="rk-contact-detail-icon rk-whatsapp">
                    <i className="fa-brands fa-whatsapp"></i>
                  </div>

                  <div>
                    <small>WHATSAPP</small>
                    <strong>Chat With Our Team</strong>
                  </div>

                  <i className="fa-solid fa-arrow-right rk-contact-detail-arrow"></i>
                </a>


                <div className="rk-contact-detail">
                  <div className="rk-contact-detail-icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>

                  <div>
                    <small>SERVICE AREA</small>
                    <strong>Noida &amp; Delhi NCR</strong>
                  </div>
                </div>


                <div className="rk-contact-detail">
                  <div className="rk-contact-detail-icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>

                  <div>
                    <small>EMAIL</small>
                    <strong>rksofaworks@gmail.com</strong>
                  </div>
                </div>

              </div>


              {/* SERVICE TAGS */}

              <div className="rk-contact-services">
                <span>Sofa Repair</span>
                <span>Re-Upholstery</span>
                <span>Foam Work</span>
                <span>Custom Sofa</span>
              </div>

            </div>


            {/* =================================================
                RIGHT SIDE FORM
            ================================================= */}
            <div className="rk-contact-form-wrap">

              <div className="rk-form-heading">

                <div>
                  <span>01</span>
                  <small>FREE SERVICE ENQUIRY</small>
                </div>

                <h2>
                  Tell us about
                  <br />
                  your <em>sofa.</em>
                </h2>

                <p>
                  Fill in the details below. Your enquiry will open
                  directly in WhatsApp.
                </p>

              </div>


              <form
                className="rk-contact-form"
                onSubmit={submitForm}
              >

                {/* NAME + PHONE */}

                <div className="rk-form-row">

                  <div className="rk-form-group">
                    <label>
                      Full Name <span>*</span>
                    </label>

                    <div className="rk-input">
                      <i className="fa-solid fa-user"></i>

                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your name"
                        required
                      />
                    </div>
                  </div>


                  <div className="rk-form-group">
                    <label>
                      Phone Number <span>*</span>
                    </label>

                    <div className="rk-input">
                      <i className="fa-solid fa-phone"></i>

                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Your phone number"
                        pattern="[0-9+\-\s]{10,15}"
                        required
                      />
                    </div>
                  </div>

                </div>


                {/* AREA */}

                <div className="rk-form-group">

                  <label>City / Area</label>

                  <div className="rk-input">
                    <i className="fa-solid fa-location-dot"></i>

                    <input
                      type="text"
                      name="area"
                      value={formData.area}
                      onChange={handleChange}
                      placeholder="e.g. Noida Sector 62"
                    />
                  </div>

                </div>


                {/* MESSAGE */}

                <div className="rk-form-group">

                  <label>What does your sofa need?</label>

                  <div className="rk-input rk-textarea">

                    <i className="fa-solid fa-message"></i>

                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      placeholder="Fabric change, foam replacement, frame repair, recliner repair..."
                    ></textarea>

                  </div>

                </div>


                {/* SUBMIT */}

                <button
                  type="submit"
                  className="rk-whatsapp-submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="rk-spinner"></span>
                      Opening WhatsApp...
                    </>
                  ) : (
                    <>
                      <i className="fa-brands fa-whatsapp"></i>

                      <span>
                        Send Enquiry on WhatsApp
                      </span>

                      <i className="fa-solid fa-arrow-right"></i>
                    </>
                  )}
                </button>


                <div className="rk-form-note">
                  <i className="fa-solid fa-shield-halved"></i>

                  Your details are used only for your sofa
                  service enquiry.
                </div>

              </form>

            </div>

          </div>
        </div>
      </section>


      {/* =====================================================
          QUICK SERVICE STRIP
      ===================================================== */}
      <section className="rk-contact-service-strip">

        <div className="container rk-contact-container">

          <div className="rk-contact-strip-title">
            <span>02</span>
            <strong>NEED HELP WITH</strong>
          </div>

          <div className="rk-contact-strip-items">

            <div>
              <i className="fa-solid fa-couch"></i>
              <span>Sofa Repair</span>
            </div>

            <div>
              <i className="fa-solid fa-layer-group"></i>
              <span>Re-Upholstery</span>
            </div>

            <div>
              <i className="fa-solid fa-wand-magic-sparkles"></i>
              <span>Sofa Makeover</span>
            </div>

            <div>
              <i className="fa-solid fa-chair"></i>
              <span>Custom Sofa</span>
            </div>

          </div>

        </div>

      </section>


      <Location />

      <Footer />
    </>
  );
}